import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of as ObservableOf } from 'rxjs/observable/of';
import { catchError, mergeMap } from 'rxjs/operators';

import { StringUtils } from '@blcloud/bl-common';
import {
  IOperationHistoryLog,
  ISnsDeliveryRequest,
} from '@blcloud/bl-datamodel';
import {
  PageId,
  LoginResourceService
} from '@blcloud/bl-ng-share-module';
import {
  OperationHistoryLogResource, SnsBulkSendHistoryResource,
  SnsDeliveryRequestResource,
} from '@blcloud/bl-ng-resource';
import { ProductCode } from '@blcloud/bl-datamodel/enum/common/product-code';
import { OpeHistoryKindDiv } from '@blcloud/bl-datamodel/enum/bizcmn/ope-history-kind-div';
import { OperationContentDiv } from '@blcloud/bl-datamodel/enum/bizcmn/operation-content-div';
import { DmExtractMenuDivMap } from '@blcloud/bl-datamodel/enum/approach/dm-extract-menu-div';
import { SnsSendPoint } from '@blcloud/bl-datamodel/enum/sns/sns-send-point';
import { RoleConst } from '@blcloud/bl-datamodel/const/role';
import { ISnsSendMessageInfo } from './sns-send-message-confirm-modal.interface';

/**
 * 送信確認モーダル サービス
 */
@Injectable()
export class SnsSendMessageConfirmModalService {

  /** コンストラクタ */
  constructor(
    private operationHistoryLogResource: OperationHistoryLogResource,
    private snsDeliveryRequestResource: SnsDeliveryRequestResource,
    private snsBulkSendHistoryResource: SnsBulkSendHistoryResource,
    private loginResourceService: LoginResourceService,
  ) {
  }

  /**
   * SNS配信
   * @param param SNS配信リクエスト
   * @param option
   * @return 登録結果
   */
  postSnsDeliveryRequest(param, option): Observable<any> {
    return this.snsDeliveryRequestResource.post<ISnsDeliveryRequest>(param, option);
  }

  /**
   * LINE一括送信の操作履歴ログを登録
   */
  postOperationHistoryLogLineBulkSend(dmExtractMenuDiv: string, snsSendTitle: string) {
    const dmExtractMenuName = DmExtractMenuDivMap[dmExtractMenuDiv];
    const opeHistoryMessage =
      StringUtils.concat(
        '『[',
        dmExtractMenuName,
        ']',
        snsSendTitle,
        '』のLINEを送信しました。',
      );

    const entity: IOperationHistoryLog = {
      // プロダクトコード
      productCode: ProductCode.Common,
      // 操作履歴種別区分
      opeHistoryKindDiv: OpeHistoryKindDiv.Record,
      // 画面ID
      pageId: PageId.LineBulkSend,
      // 操作履歴機能名称
      opeHistoryFunctionName: 'LINE一斉送信',
      // 操作内容区分
      operationContentDiv: OperationContentDiv.Send,
      // 操作履歴メッセージ配列
      opeHistoryMessageList: [opeHistoryMessage],
      // サブジェクト
      subjects: {
        sf: {}
      }
    };

    this.operationHistoryLogResource.post<IOperationHistoryLog>(entity).pipe(
      catchError(() => {
        return ObservableOf(null);
      })
    ).subscribe();
  }

  /**
   * LINE一斉送信のロールを取得
   */
  isAvailableLineBulkSendRole(): Observable<boolean> {
    return this.loginResourceService.isAvailableFunction(RoleConst.ROLEID_FUNC_ALL_LINE_BULK_SEND);
  }

  /**
   * LINEメッセージプレビューデータ作成
   */
  createPreview(snsSendMessageInfo: ISnsSendMessageInfo): Observable<string[]> {
    return this.loginResourceService.getLoginUserEmployeeBindModel().pipe(
      mergeMap(loginUser => {
        const body = {
          blTenantId: loginUser.blTenantId,
          snsDiv: snsSendMessageInfo.snsDiv,
          snsSendPoint: SnsSendPoint.FriendSend,
          ticketCodeList: snsSendMessageInfo.ticketCodeList,
          dmContentNumber: snsSendMessageInfo.dmContentNumber,
          dmContentName: snsSendMessageInfo.dmContentName,
          dmExtractMenuCode: snsSendMessageInfo.dmExtractMenuCode,
          dmExtractMenuDiv: snsSendMessageInfo.dmExtractMenuDiv,
          dmContentTitle: snsSendMessageInfo.dmContentTitle,
          messageContents: snsSendMessageInfo.dmContentBody,
          dmSnsMsgSettingList: snsSendMessageInfo.dmContentInfo.dmSnsMsgSettingList,
        };
        return this.snsBulkSendHistoryResource.post(body, {entityOptions: {exPath: 'preview'}});
      })
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/sns-send-message-confirm-modal/sns-send-message-confirm-modal.service.ts